import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import { ICCGTakerByIdRequest, ICCGTakerRequest, ICCGTakerResponse } from "../interfaces/ccg-taker.interface";
import { IResponseData, IResponseListDataPaginate } from "../interfaces/response-data.interface";

@Injectable({
	providedIn: "root"
})
export class CCGTakerService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getAll(request: ICCGTakerRequest): Observable<IResponseListDataPaginate<ICCGTakerResponse>> {
		let params = new HttpParams();
		if (
			request.companyNameTaker !== "" &&
			request.companyNameTaker !== undefined &&
			request.companyNameTaker !== null
		) {
			params = params.append("companyNameTaker", request.companyNameTaker);
		}
		if (request.cnpjTaker !== "" && request.cnpjTaker !== undefined && request.cnpjTaker !== null) {
			params = params.append("cnpjTaker", request.cnpjTaker);
		}
		if (request.personName !== "" && request.personName !== undefined && request.personName !== null) {
			params = params.append("personName", request.personName);
		}
		if (request.personDocument !== "" && request.personDocument !== undefined && request.personDocument !== null) {
			params = params.append("personDocument", request.personDocument);
		}
		if (request.status !== "" && request.status !== undefined && request.status !== null) {
			params = params.append("status", request.status);
		}
		if (request.initialdate !== "" && request.initialdate !== undefined && request.initialdate !== null) {
			params = params.append("initialdate", request.initialdate);
		}
		if (request.finaldate !== "" && request.finaldate !== undefined && request.finaldate !== null) {
			params = params.append("finaldate", request.finaldate);
		}
		if (request.page !== undefined) {
			params = params.append("page", request.page.toString());
		}
		if (request.pageSize !== undefined) {
			params = params.append("pageSize", request.pageSize.toString());
		}
		return this.http.get<IResponseListDataPaginate<ICCGTakerResponse>>(`${environment.urlApi}/legalperson`, { params });
	}

	sendDocument(id: number): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/CCG/SendDocument?idLegalPerson=${id}`);
	}

	printDocument(id: number): Observable<any> {
		return this.http.get(`${environment.urlApi}/CCG/PrintDocument?idLegalPerson=${id}`, { responseType: "blob" });
	}

	getById(id: number): Observable<IResponseData<ICCGTakerByIdRequest>> {
		return this.http.get<IResponseData<ICCGTakerByIdRequest>>(`${environment.urlApi}/LegalPersonByTakerId?id=${id}`);
	}
}
